import React from 'react';
import styles from './main.module.css';
import Button from '../../components/button/Button';
import PageBg from '../../components/pageBg/PageBg';
import ShadowBottom from '../../components/shadowBottom/shadowBottom';
import { TScrollPage } from '../../utils/types';

import main_blur_bg from '../../images/main_bg_blur.svg';
import sparks from '../../images/sparks.png';
import main_person_blur from '../../images/main_person_blur.png';
import main_person from '../../images/main_person.png';
import { scrollToSection } from '../../utils/pageScroll';
import amazing_title from '../../images/amazing_title.svg';


// Сколько показывается одна фраза; полоска под текстом заполняется за это время
const SLIDE_MS = 10000;
// Длительность исчезновения старой фразы перед появлением новой
const TEXT_OUT_MS = 320;

const Main: React.FC<TScrollPage> = ({reference}) => {
  const [index, setIndex] = React.useState<number>(0);
  const [leaving, setLeaving] = React.useState(false);
  const leaveTimer = React.useRef<number | undefined>(undefined);
  const data = [
    {
      title: 'Ролеплей проект на платформе Arma 3',
      description: 'Каждый может попробовать себя в различных ролях и взаимодействовать с другими игроками в реальном времени'
    },
    {
      title: 'Ролеплей сервер #1 (в России и СНГ)',
      description: 'Исходя из статистики www.battlemetrics.com'
    },
    {
      title: 'Уникальный мод',
      description: 'Каждый аспект был тщательно проработан нашей командой, чтобы предоставить вам неповторимый игровой опыт'
    }
  ];

  // Смена фразы: старая плавно гаснет, затем появляется новая.
  // Следующую фразу включает конец анимации полоски (onAnimationEnd), поэтому
  // при наведении на блок показ ставится на паузу вместе с полоской.
  const goTo = React.useCallback((next: number) => {
    window.clearTimeout(leaveTimer.current);
    setLeaving(true);
    leaveTimer.current = window.setTimeout(() => {
      setIndex(next);
      setLeaving(false);
    }, TEXT_OUT_MS);
  }, []);
  React.useEffect(() => () => window.clearTimeout(leaveTimer.current), []);
  const next = () => goTo(index === data.length - 1 ? 0 : index + 1);

  const goToInstall = () => {
    scrollToSection('howtoinstall');
  }

  return (
    <PageBg 
      type='main'
      radial='bottom'
      id='main'
      reference={reference}
      opacity={1}
    >
      <img className={styles.blur_bg} src={main_blur_bg} alt="" />
      <img className={styles.sparks} src={sparks} alt="" />
      <img className={styles.person_blur} src={main_person_blur} alt="" />
      <img className={styles.person} src={main_person} alt="" />
      <ShadowBottom/>

      <div className={styles.textContainerMain}>
        <div className={styles.textContainerBg}></div>
        <img className={styles.amazingTitle} src={amazing_title} alt="" />
        <div>
        <div className={`${styles.textContainer} ${leaving ? styles.textLeaving : ''}`} aria-live="polite">
          <div key={index} className={styles.textSlide}>
            <h1 className={styles.title}>{data[index].title}</h1>
            <p className={styles.description}>{data[index].description}</p>
          </div>
        </div>
        </div>
        <div className={styles.slideBtnContainter}>
          {data.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Слайд ${i + 1}`}
              aria-current={i === index}
              onClick={() => { if (i !== index) goTo(i); }}
              className={`${styles.slideBtn} ${i < index ? styles.slideBtn_done : ''}`}
            >
              {i === index && (
                <span
                  key={`fill-${index}`}
                  className={styles.slideFill}
                  style={{ animationDuration: `${SLIDE_MS}ms` }}
                  onAnimationEnd={next}
                />
              )}
            </button>
          ))}
        </div>
      </div>


      <div className={styles.container}>
        <Button size={'medium'} color={'orange'} text={'normal'} borderRadius={15} type="button" disable={false} onClick={goToInstall}>НАЧАТЬ ИГРАТЬ</Button>
      </div>
    </PageBg>
  );
}

export default Main;
